import React, { Component } from "react";
import { useNavigation } from "../../utilities/NavigationContext";

class BillingCancel extends Component {
  goToPricing = () => {
    this.props.navigate("/pricing");
  };

  goToPlanning = () => {
    this.props.navigate("/planning"); // same as other success/cancel pages
  };

  render() {
    return (
      <div className="p-5 text-center bg-slate-100 text-md rounded shadow m-20">
        <h1 className="text-xl font-bold my-4">Subscription Cancelled ❌</h1>

        <p>Your subscription purchase was cancelled or not completed.</p>

        <div className="mt-20">
          <button
            onClick={this.goToPricing}
            className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4 mr-4"
          >
            Try Again
          </button>

          <button
            onClick={this.goToPlanning}
            className="bg-sky-700 hover:bg-sky-800 text-white rounded shadow p-4"
          >
            Go to Planning
          </button>
        </div>
      </div>
    );
  }
}

const BillingCancelWithNavigation = (props) => {
  const navigate = useNavigation();
  return <BillingCancel {...props} navigate={navigate} />;
};

export default BillingCancelWithNavigation;
